// extracted by mini-css-extract-plugin
export var modal = "_gk-0";